import React from 'react';
import {
	Avatar,
	ListItem,
	ListItemText,
	ListItemIcon,
	Box
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Photo } from '@mui/icons-material';

const EditorialItem = ({ editorial, handleClick, ...rest }) => {
	const classes = useStyles();
	return (
		<ListItem button onClick={handleClick}>
			<ListItemIcon>
				<Avatar size={80} variant="rounded" src={editorial.image_url}>
					<Photo />
				</Avatar>
			</ListItemIcon>
			<ListItemText primary={editorial.title} />
		</ListItem>
	);
};

export default EditorialItem;

const useStyles = makeStyles((theme) => ({
	icon: {
		color: theme.palette.common.grey
	}
}));
